// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__kVpdt","content":"Message_content__1Zk2x"};